import { Box, Typography } from '@mui/material'
import { toJS } from 'mobx'
import { useCallback } from 'react'
import { ContainerJourneyStatus } from './molecules/ContainerJourneyStatusChip'

interface Props {
  deletableCount: number
  nonDeletableStatusCounts: { [key: string]: number }
  t: (key: string, text: string, options?: any) => string
}

export const DeleteConfirmationBody = ({ deletableCount, nonDeletableStatusCounts, t }: Props) => {
  const plainStatusCounts = toJS(nonDeletableStatusCounts)
  const isMixedSelection = Object.keys(plainStatusCounts).length > 0

  const getStatusLabel = useCallback(
    (value: ContainerJourneyStatus) => {
      switch (value) {
        case ContainerJourneyStatus.Arrived:
          return t('arrived', 'arrived')
        case ContainerJourneyStatus.OnTerminal:
          return t('onTerminal', 'on terminal')
        case ContainerJourneyStatus.OnYard:
          return t('onYard', 'on yard')
        case ContainerJourneyStatus.Departed:
          return t('departed', 'departed')
        case ContainerJourneyStatus.Expected:
          return t('expected', 'expected')
        default:
          return t('expected', 'expected')
      }
    },
    [t],
  )

  if (!isMixedSelection) {
    return (
      <Box>
        <Typography component='div' sx={{ mb: 2 }}>
          {t(
            'deletingWillRemoveInfo',
            'Deleting these containers will remove all related information.',
          )}
        </Typography>
        <Typography component='div'>
          {t('changeCannotBeUndone', 'This change cannot be undone.')}
        </Typography>
      </Box>
    )
  }

  return (
    <Box>
      <Typography component='div' sx={{ mb: 1 }}>
        {t('cannotBeRemovedHeader', 'Containers that have the following status CANNOT be removed:')}
      </Typography>

      {Object.entries(plainStatusCounts).map(([status, count]) => {
        const actualStatus = getStatusLabel(status).toLowerCase()

        return (
          <Typography key={status}>
            {t('{count} {actualStatus} containers', '{count} {actualStatus} containers', {
              count,
              actualStatus,
            })}
          </Typography>
        )
      })}

      <Typography component='div' sx={{ mt: 2, mb: 1 }}>
        {t(
          'willBeRemovedHeader',
          'Only expected containers will remove with all related information:',
        )}
      </Typography>
      <Typography>
        {t('{count} expected containers', '{count} expected containers', {
          count: deletableCount,
        })}
      </Typography>
      <Typography component='div' sx={{ mt: 2 }}>
        {t('changeCannotBeUndone', 'This change cannot be undone.')}
      </Typography>
    </Box>
  )
}
